import { lazy } from "react";

import { getDecisioningStudioAgentEditUrlAllowed } from "@navigationRouting/decisioning_studio/agents/getDecisioningStudioAgentEditUrlAllowed";
import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DecisioningStudioAgentEditPage = lazy(() =>
  import("@scenes/OfferFit/components/DecisioningStudioAgentEditPage").then((module) => ({
    default: module.DecisioningStudioAgentEditPage,
  }))
);

export const decisioningStudioAgentWizardNRO: NavigationRoutingObject = {
  Component: DecisioningStudioAgentEditPage,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "offerfit",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("decisioning-studio-agent-wizard-nro-heading", "Configure BrazeAI Decisioning Studio™ Agent"),
  pageNameForTracking: () => "Configure BrazeAI Decisioning Studio™ Agent",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("decisioning-studio-agent-wizard-nro-description", "Configure a BrazeAI Decisioning Studio™ agent"),
  tag: "new",
  // A Pro agent's action bank editor opens read-only for action bank viewers, so this URL lets them
  // in too. The page picks the editor, the wizard or a redirect.
  getDeveloperNavigationAllowed: getDecisioningStudioAgentEditUrlAllowed,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/decisioning_studio/agents/:appGroupId",
};
